import { Link } from "react-router-dom";
import { Container } from "../../../shared";
import {
  FileText,
  Download,
  ExternalLink,
  ShieldCheck,
  BadgeCheck,
  MapPin,
  Wrench,
  GraduationCap,
  Cpu,
  Globe,
} from "lucide-react";

const mainGridData = {
  announcements: [
    {
      id: 1,
      type: "Important",
      date: "15 Mar 2026",
      text: "Drone registration portal updated — all operators must re-verify by April 30, 2026",
    },
    {
      id: 2,
      type: "Important",
      date: "15 Mar 2026",
      text: "Drone registration portal updated — all operators must re-verify by April 30, 2026",
    },
  ],

  events: [
    {
      id: 1,
      date: "22",
      month: "Mar",
      title: "National Drone Innovation Summit",
      location: "Panchkula Convention Centre",
      tag: "Summit",
    },
    {
      id: 2,
      date: "22",
      month: "Mar",
      title: "National Drone Innovation Summit",
      location: "Panchkula Convention Centre",
      tag: "training",
    },
  ],

  resources: [
    {
      id: 1,
      title: "Drone Import Policy 2026",
      size: "PDF, 2.1 MB",
    },
  ],

  links: [
    "DGCA – Drone Rules 2021",
    "Make in India – Drone Sector",
    "NPNT Compliance Portal",
    "MeitY Drone Guidelines",
    "Haryana Government Portal",
  ],
};

const Resources = ({ data, links }) => {
  return (
    <div className="flex flex-col gap-4">
      {/* Resources */}
      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        <div className="flex justify-between items-center bg-[#0B3C6D] text-white px-4 py-2 text-sm font-semibold">
          <span>Resources & Documents</span>
          {/* <button className="text-xs text-yellow-300 bg-transparent border-0 font-medium hover:underline p-0">
            All Docs
          </button> */}
        </div>

        <div className="p-3 space-y-3 cursor-not-allowed">
          {data.map((doc) => (
            <div
              key={doc.id}
              className="flex items-center justify-between text-xs"
            >
              <div className="flex items-center gap-2">
                <FileText className="w-4 h-4 text-red-500" />
                <div>
                  <p className="text-gray-800">{doc.title}</p>
                  <p className="text-[10px] text-gray-400">{doc.size}</p>
                </div>
              </div>

              <Download className="w-4 h-4 text-gray-400 cursor-pointer" />
            </div>
          ))}
        </div>
      </div>

      {/* Links */}
      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        <div className="bg-[#0B3C6D] text-white px-4 py-2 text-sm font-semibold">
          Useful Links
        </div>

        <div className="grid grid-cols-2 gap-2 p-3 text-xs">
          {links.map((link, index) => (
            <div
              key={index}
              className="flex items-center gap-1 text-[#0B3C6D] hover:underline cursor-pointer"
            >
              <ExternalLink className="w-3 h-3" />
              {link}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const MainGrid = ({ data = mainGridData }) => {
  const quickAccess = [
    { label: "Register Drone", icon: ShieldCheck, link: "/vendor-onboarding" },
    { label: "Drone City", icon: BadgeCheck, link: "https://dronecityharyana.com/" },
    { label: "Find DSK Centre", icon: MapPin, link: "https://avplinternational.com/dsk" },
    { label: "Find Drone", icon: FileText, link: "/product/all-drone" },
    { label: "Book Maintenance", icon: Wrench, link: "/daas-service-page" },
    { label: "Find Drone Parts", icon: GraduationCap, link: "/drone-parts" },
    { label: "Find Jobs", icon: Cpu, link: "/jobs-hire-page" },
    { label: "Get Certified", icon: Globe, link: "/training-courses/0" },
  ];
  return (
    <section className="pb-4">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {/* <Announcements data={data.announcements} /> */}
          {/* About container1 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-sm">
            <div className="bg-[#003580] text-white px-4 py-2 text-sm font-semibold">
              About Drone Planet
            </div>

            <div className="p-4 text-sm text-gray-700 space-y-3">
              <p>
                Drone Planet is India’s integrated drone ecosystem platform,
                connecting manufacturers, pilots, businesses, and service
                providers in one unified space. From drone marketplace access to
                Drone-as-a-Service solutions and certified training, it enables
                scalable adoption, job creation, and entrepreneurship while
                supporting DGCA-compliant operations across agriculture,
                infrastructure, surveillance, and emerging drone applications.
              </p>

              {/* <button className="text-[#0B3C6D] bg-transparent font-medium text-xs border-0">
                Read More
              </button> */}
            </div>
          </div>

          {/* Quick Access */}
          <div className="bg-white rounded-lg overflow-hidden shadow-sm">
            <div className="bg-[#0B3C6D] text-white px-4 py-2 text-sm font-semibold">
              Quick Access
            </div>

            <div className="grid grid-cols-2 gap-2 p-3">
              {quickAccess?.map((item, index) => {
                const Icon = item.icon;
                return (
                  <Link
                    to={item.link}
                    key={index}
                    className="flex items-center gap-2 px-3 py-2 rounded-md text-xs text-[#0B3C6D] bg-[#EFF6FF] hover:bg-[#DBEAFE] transition border-0"
                  >
                    <Icon className="w-4 h-4 text-[#0B3C6D]" />
                    {item.label}
                  </Link>
                );
              })}
            </div>
          </div>
          {/* About container2 /> */}
          <div className="bg-white rounded-lg overflow-hidden shadow-sm">
            <div className="bg-[#003580] text-white px-4 py-2 text-sm font-semibold">
              About Drone Tech Multi Co-operative Society
            </div>

            <div className="p-4 text-sm text-gray-700 space-y-3">
              <p>
                Drone Tech Multi-State Co-operative Society Limited has been
                established to create an organized, inclusive and future-ready
                ecosystem for the drone sector. It unites drone pilots,
                manufacturers, component makers, students, and institutions
                under one cooperative platform.
              </p>
              <p>
                The portal provides a unified platform for drone registration,
                pilot certification, marketplace transactions, policy documents,
                and training programs — ensuring compliance with DGCA
                regulations.
              </p>

              {/* <button className="text-[#0B3C6D] bg-transparent font-medium text-xs border-0">
                Read More
              </button> */}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default MainGrid;
